import { VerticalData } from './vertical';

export const cpgMediaTypeData = [
  {
    name: 'Digital Overall (iROAS)',
    lowerQuartile: '$0.70',
    median: '$1.75',
    upperQuartile: '$5.22',
  },
] as const satisfies readonly VerticalData[];
